import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { NotificationCenter } from './NotificationCenter';
import { RealtimeWorkWidget } from './RealtimeWorkWidget';
import { UserMenu } from './UserMenu';

interface Props {
  onMenuToggle?: () => void;
  menuOpen?: boolean;
}

export function Header({ onMenuToggle, menuOpen }: Props = {}): JSX.Element {
  return (
    <header className="app-shell__header">
      <div className="app-shell__header-left">
        {/* 햄버거 — 모바일에서만 표시 (CSS). */}
        <button
          type="button"
          className="app-shell__menu-toggle"
          onClick={onMenuToggle}
          aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={menuOpen}
          aria-controls="app-sidebar"
        >
          {menuOpen ? <X size={20} strokeWidth={1.75} /> : <Menu size={20} strokeWidth={1.75} />}
        </button>
        <div className="app-shell__logo">
          <Logo size={22} />
        </div>
      </div>
      <div className="app-shell__header-right">
        <NotificationCenter />
        <RealtimeWorkWidget />
        <UserMenu />
      </div>
    </header>
  );
}
